import { Link } from 'react-router-dom';

export function HomeFooter() {
  return (
    <footer className="border-t border-[#262626] py-8 px-4 sm:px-8 bg-[#050505]">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <Link to="/my-purchases" className="text-[#6B7B8D] hover:text-[var(--accent,#DAA520)] text-xs uppercase tracking-wider transition-colors" data-testid="footer-my-purchases-link">
          My Purchases
        </Link>
        <p className="text-[#6B7B8D] text-sm">
          &copy; {new Date().getFullYear()} DugOwtBoi Entertainment™ — All rights reserved.
        </p>
      </div>
    </footer>
  );
}
